import { PaginationTable, Table, TableWrapper } from 'components/Global';
import React, { useEffect, useState } from 'react';
import { ReactComponent as DriverIcon } from 'icons/driving-wheel-icon.svg';
import EmptyState from 'components/Global/EmptyState';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllNewRegisteredDrivers } from 'features/drivers/actions';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import { resetSelectedDriver } from 'features/drivers/slice';

const column = [
  { header: 'No.', value: 'no' },
  { header: 'Nama', value: 'name' },
  { header: 'Email', value: 'email' },
  { header: 'No. Handphone', value: 'phone_number' },
  { header: 'Status', value: 'status' },
];

const DriverVerification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data, isLoading } = useSelector((state) => state.drivers);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getAllNewRegisteredDrivers(currentPage));
  }, [currentPage]);

  const handleDetail = (e) => {
    const id = e.target.parentElement.parentElement.dataset['key'];
    dispatch(resetSelectedDriver());
    navigate(`/driver/verification/${id}`);
  };

  const processedData = data?.users?.map((item) => ({
    id: item.id,
    name: item.name,
    email: item.email,
    phone_number: item.phone,
    status: item.status === 'new' ? 'verification' : item.status,
  }));

  const driverVerificationListView = () => {
    if (processedData?.length === 0 && !isLoading) {
      return <EmptyState />;
    } else {
      return (
        <>
          <Table column={column} actionBtn onDetail={handleDetail} data={processedData} currentPage={currentPage} />
          <PaginationTable
            currentPage={currentPage}
            onPageChange={(newPage) => setCurrentPage(newPage)}
            totalCount={data?.pagination?.total_data}
          />
        </>
      );
    }
  };

  return (
    <div>
      <TableWrapper icon={<DriverIcon fill="#009EF7" width="25px" height="25px" />} title="Driver">
        {isLoading ? <LoadingSpinner /> : driverVerificationListView()}
      </TableWrapper>
    </div>
  );
};

export default DriverVerification;
